import React from 'react';
import PropTypes from 'prop-types';
import fixImageUrl from '../../../../helpers/fixImageUrl';
import OptionSummary from './OptionSummaryConnector';
import QuantityContainer from './QuantityContainerConnector';


const ItemProduct = ({
  itemProduct,
  itemId,
}) => (
  <div className="itemProductInfo">
    <div className="itemProduct">
      <div className="productDetails">
        <img
          className="productImage"
          src={itemProduct.mainImageUrl.split('/').slice(3, 4).toString()
            === window.globals.advancedVisualizationBaseUrl.split('/').slice(3, 4).toString()
            ? itemProduct.mainImageUrl : fixImageUrl(itemProduct.mainImageUrl)}
          alt={itemProduct.productName}
        />
        <div className="productSummary">
          <div className="productName">
            <h4 className="brandName">{itemProduct.brand}</h4>
            <h4>{itemProduct.productName}</h4>
          </div>
          <OptionSummary itemId={itemId} />
        </div>
      </div>
    </div>
    <div id="itemQuantity">
      <QuantityContainer itemId={itemId} />
    </div>
  </div>
);

ItemProduct.propTypes = {
  itemProduct: PropTypes.shape({
    brand: PropTypes.string.isRequired,
    mainImageUrl: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
  }).isRequired,
  itemId: PropTypes.string.isRequired,
};

export default ItemProduct;
